// src/components/ResourceAccessPrompt.jsx
import React, { useState } from 'react';
import { FaLock, FaCheck, FaArrowRight, FaMedal, FaChartLine, FaHandshake, FaLightbulb } from 'react-icons/fa';
import './ResourceAccessPrompt.css';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

const ResourceAccessPrompt = ({ resource }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const { resourceId } = useParams();
    console.log(resourceId);

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/dashboard";

    console.log(from)
    // Dados do recurso (pode ser passado como prop)
    const resourceData = resource || {
        id: "construtor_habilidades",
        title: "Construtor de Habilidades",
        description: "Ferramenta para desenvolver qualquer habilidade rapidamente com suporte da IA",
        features: [
            "Planos de estudo personalizados",
            "Acompanhamento diário por IA",
            "Relatórios de progresso detalhados",
            "Certificado de conclusão",
            "Suporte de mentores especializados"
        ],
        benefits: [
            "Aumente sua empregabilidade",
            "Desenvolva habilidades em alta demanda",
            "Alcance objetivos profissionais mais rápido",
            "Diferencie-se no mercado"
        ]
    };

    const steps = [
        {
            title: "Selecione o módulo",
            description: "Escolha o módulo que deseja adquirir na nossa plataforma"
        },
        {
            title: "Complete seu perfil",
            description: "Preencha suas informações para personalizarmos sua experiência"
        },
        {
            title: "Escolha o plano",
            description: "Selecione entre nossas opções de pagamento"
        },
        {
            title: "Acesso imediato",
            description: "Comece a aprender imediatamente após a confirmação"
        }
    ];

    const handleNextStep = () => {
        setCurrentStep(prev => (prev < steps.length - 1 ? prev + 1 : 0));
    };

    const handlePurchase = () => {
        // Lógica para iniciar o processo de compra
        console.log("Iniciando compra do recurso:", resourceData.id);
        alert("Você será redirecionado para a página de compra!");
        navigate('/')
    };

    return (
        <div className="access-prompt-container " style={{ overflowY: "auto", height: '100%' }}>
            <div className="access-prompt-card">
                {/* Cabeçalho com ícone de cadeado */}
                <div className="prompt-header">
                    <div className="lock-icon">
                        <FaLock />
                    </div>
                    <h2>Acesso Exclusivo</h2>
                    <p>Este recurso requer acesso especial</p>
                </div>

                {/* Representação do recurso */}
                <div className="resource-preview">
                    <h3 className="resource-title">{resourceData.title}</h3>
                    <p className="resource-description">{resourceData.description}</p>

                    <div className="resource-features">
                        {resourceData.features.map((feature, index) => (
                            <div className="feature-item" key={index}>
                                <FaCheck className="feature-icon" />
                                <span>{feature}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Benefícios */}
                <div className="benefits-section">
                    <h4>O que você vai conquistar:</h4>
                    <div className="benefits-grid">
                        <div className="benefit-card">
                            <FaMedal className="benefit-icon" />
                            <h5>Domínio de Habilidades</h5>
                            <p>Desenvolva competências valiosas para sua carreira</p>
                        </div>
                        <div className="benefit-card">
                            <FaChartLine className="benefit-icon" />
                            <h5>Progresso Mensurável</h5>
                            <p>Acompanhe seu desenvolvimento com métricas precisas</p>
                        </div>
                        <div className="benefit-card">
                            <FaHandshake className="benefit-icon" />
                            <h5>Oportunidades Profissionais</h5>
                            <p>Aumente suas chances no mercado de trabalho</p>
                        </div>
                        <div className="benefit-card">
                            <FaLightbulb className="benefit-icon" />
                            <h5>Autoconhecimento</h5>
                            <p>Descubra seu potencial e áreas de melhoria</p>
                        </div>
                    </div>
                </div>

                {/* Passos para adquirir */}
                <div className="steps-section">
                    <h4>Como adquirir acesso:</h4>
                    <div className="steps-progress">
                        {steps.map((step, index) => (
                            <div
                                key={index}
                                className={`step-item ${index === currentStep ? 'active' : ''}`}
                                onClick={() => setCurrentStep(index)}
                            >
                                <div className="step-number">{index + 1}</div>
                                <div className="step-info">
                                    <h5>{step.title}</h5>
                                    <p>{step.description}</p>
                                </div>
                                {index < steps.length - 1 && (
                                    <div className="step-arrow">
                                        <FaArrowRight />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Call to Action */}
                <div className="cta-section">
                    <button className="cta-button" onClick={handlePurchase}>
                        Solicitar Acesso Agora
                    </button>
                    <p className="cta-note">Comece sua jornada de transformação hoje mesmo</p>
                </div>
                {/* Retunr Action */}
                <div className="resource-preview flex flex-col justify-center items-center py-2">
                    <Link to={'/'} onClick={handleNextStep} className="feature-item cursor-pointer">
                        Continuar a explorar
                    </Link>
                    <p className="cta-note">Continue a explorar o app.</p>
                </div>
            </div>
        </div>
    );
};

export default ResourceAccessPrompt;